'use strict';
var i18n = require('shared/scripts/modules/utils/i18n');

var options = {
    ns: ['corpJourney', 'lcr', 'plan-names', 'common'],
    defaultNS: 'corpJourney',
    backend: {
        loadPath: function(lng, ns){
            if(ns.indexOf('plan-names') !== -1){
                return '/online-services/plan-names';
            }else{
                return '/groups/' + 'locales/' + lng + '/' + ns + '.json';
            }
        }
    }
};

var initialized;

function init() {
    if (initialized === undefined) {
        initialized = i18n.doSetup(options);
    }
    return initialized;
}


module.exports = {
    init: init,
    translate: i18n.translate
};




//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/modules/utils/i18n.js
// module id = olBI
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14